import { useQueryClient } from 'react-query';

import { Config } from '@nw/shared/config';

const CommonDataCountriesURL = `${Config['COMMON_DATA_COUNTRIES_BASE_URL']}`;

const fetchCountriesData = (signal) => {
  return fetch(CommonDataCountriesURL, {
    signal,
    method: 'POST',
    body: JSON.stringify({
      data: JSON.stringify(
        JSON.stringify({
          country_id: 1
        })
      ),
      clientKeyDetailsId: 1
    }),
    headers: { 'content-type': 'application/json' }
  }).then((res) => res.json());
};

const countriesListQuery = (signal) => ({
  queryKey: ['countriesList'],
  queryFn: async () => fetchCountriesData(signal)
});

export const useQueryClientCountriesHook = async (signal) => {
  const queryClient = useQueryClient();
  const query = countriesListQuery(signal);

  if (queryClient.getQueryData(query.queryKey)) {
    return queryClient.getQueryData(query.queryKey);
  }
  return await queryClient.fetchQuery(query.queryKey, query.queryFn, {
    cacheTime: Infinity
  });
};
